import {Injectable, Injector} from '@angular/core';
import {Actions, createEffect, ofType} from '@ngrx/effects';
import {of} from 'rxjs';
import {catchError, map, mergeMap} from 'rxjs/operators';

import * as ac from './actions.command.pruefaufgabe-hinzufuegen';
import * as api from '../../../clients/qschecks';

@Injectable()
export class QschecksPruefaufgabeHinzufuegenEffects {

    PruefaufgabeHinzufuegen$ = createEffect(() => this.actions$.pipe(
        ofType(ac.POST_PRUEFAUFGABE_HINZUFUEGEN),
        mergeMap((x: ac.PostPruefaufgabeHinzufuegenAction) => {
            const optPayload = (x !== undefined && x !== null && x.optPayload !== undefined) ? x.optPayload : null;
            return this.getService().postPruefaufgabeHinzufuegen(x.pruefaufgabeModelRequest).pipe(
                map((result: any) => {
                    return new ac.PostPruefaufgabeHinzufuegenErfolgreichAction(result, x.pruefaufgabeModelRequest, optPayload);
                }),
                catchError((error: any) => {
                    const nextAction = new ac.PostPruefaufgabeHinzufuegenFehlerAction(error, x.pruefaufgabeModelRequest, optPayload);
                    return of(nextAction);
                })
            );
        })
    ));

    private service: api.AdminCommandService = null;

    constructor(private actions$: Actions, private injector: Injector) {
    }

    private getService(): api.AdminCommandService {
        if (this.service === null) {
            this.service = this.injector.get(api.AdminCommandService);
        }
        return this.service;
    }
}
